// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"919ffca8","977":"c4ad5a7a"}[chunkId] + ".chunk.js";
};